"use client";
import { j as P } from "./jsx-runtime-CJ-St4mQ.mjs";
import * as c from "react";
import { useId as F } from "react";
import { u as _ } from "./useControlled-B2rPEZCb.mjs";
import { u as O } from "./useEventCallback-CjuAhyNz.mjs";
import { u as S } from "./useBaseUiId-a-UPSsPQ.mjs";
import { u as A } from "./useRenderElement-B8V3_e8R.mjs";
import { P as B, b as D } from "./CheckboxRoot-VdDogCRp.mjs";
import { u as H, f as T } from "./FieldRootContext-Cj7-dNhd.mjs";
import { u as U, a as K } from "./useFieldControlValidation-B3M7EPH2.mjs";
const M = [];
function X(C) {
  const {
    allValues: s = M,
    value: e = M,
    onValueChange: p
  } = C, x = c.useRef(e), a = c.useRef(/* @__PURE__ */ new Map()), [f, h] = c.useState("mixed"), t = S(), k = e.length === s.length, m = e.length !== s.length && e.length > 0, r = O(p), b = c.useCallback(() => ({
    id: t,
    indeterminate: m,
    checked: k,
    "aria-controls": s.map((n) => `${t}-${n}`).join(" "),
    onCheckedChange(n, i) {
      const o = x.current, l = s.filter((d) => a.current.get(d) && o.includes(d)), u = s.filter((d) => !a.current.get(d) || a.current.get(d) && o.includes(d));
      if (o.length === u.length || o.length === 0) {
        e.length === u.length ? r(l, i) : r(u, i);
        return;
      }
      f === "mixed" ? (r(u, i), h("on")) : f === "on" ? (r(l, i), h("off")) : f === "off" && (r(o, i), h("mixed"));
    }
  }), [s, k, t, m, r, f, e.length]), V = c.useCallback((n) => ({
    name: n,
    id: `${t}-${n}`,
    checked: e.includes(n),
    onCheckedChange(i, o) {
      const l = e.slice();
      i ? l.push(n) : l.splice(l.indexOf(n), 1), x.current = l, r(l, o), h("mixed");
    }
  }), [t, r, e]);
  return c.useMemo(() => ({
    id: t,
    indeterminate: m,
    getParentProps: b,
    getChildProps: V,
    disabledStatesRef: a
  }), [t, m, b, V]);
}
const j = /* @__PURE__ */ c.forwardRef(function(s, e) {
  const {
    allValues: p,
    className: x,
    defaultValue: a,
    disabled: f = !1,
    id: h,
    onValueChange: t,
    render: k,
    value: m,
    ...r
  } = s, {
    disabled: b,
    labelId: V,
    name: n,
    state: i
  } = H(), o = b || f, l = U(), [u, E] = _({
    controlled: m,
    default: a,
    name: "CheckboxGroup",
    state: "value"
  }), d = O((g, v) => {
    E(g), t == null || t(g, v);
  }), N = X({
    allValues: p,
    value: m,
    onValueChange: t
  }), y = S(h), R = c.useRef(null), G = O((g) => {
    R.current == null && g != null && !g.hasAttribute(B) && (R.current = g);
  });
  K({
    enabled: !!n,
    id: y,
    commitValidation: l.commitValidation,
    value: u,
    controlRef: R,
    name: n,
    getValue: () => u
  });
  const I = c.useMemo(() => ({
    ...i,
    disabled: o
  }), [i, o]), $ = c.useMemo(() => ({
    allValues: p,
    value: u,
    defaultValue: a,
    setValue: d,
    parent: N,
    disabled: o,
    fieldControlValidation: l,
    registerControlRef: G
  }), [p, u, a, d, N, o, l, G]), w = A("div", s, {
    state: I,
    ref: e,
    props: [{
      role: "group",
      "aria-labelledby": V
    }, r],
    customStyleHookMapping: T
  });
  return /* @__PURE__ */ P.jsx(D.Provider, {
    value: $,
    children: w
  });
});
process.env.NODE_ENV !== "production" && (j.displayName = "CheckboxGroup");
const te = (C) => {
  const { label: s, id: e, children: p, ...x } = C, a = F(), f = e ?? a;
  return /* @__PURE__ */ P.jsxs(
    j,
    {
      className: "flex flex-col items-start gap-1 text-gray-900",
      ...x,
      children: [
        /* @__PURE__ */ P.jsx("div", { className: "font-regular", id: f, children: s }),
        p
      ]
    }
  );
};
export {
  te as default
};
